import { render, staticRenderFns } from "./DeleteConfirmationDialog.vue?vue&type=template&id=4175555b"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../routestatus/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports